import gql from "graphql-tag"
import IngestionSourceFragment from "../fragment/IngestionSourceFragment"

export default gql`
  ${IngestionSourceFragment}
  mutation ingestionSourceEdit($id: String!, $input: IngestionSourceInput!) {
    ingestionSourceEdit(id: $id, input: $input) {
      ...IngestionSourceFragment
    }
  }
`
